export default __webpack_public_path__ + "static/media/VI.4bc4f409.svg";